/**
 * Sends a Telegram notification by forwarding the request to the secure backend relay.
 * @param {string} message - The message text to send.
 * @param {string} type - Notification type key. Used to check if the user disabled this type.
 *   Special value 'speed_alert' bypasses the generic per-type filter (it has its own toggle).
 */
import { getAuthToken } from '../config/supabase';
import { maybeSendPush, getNotificationChannel } from './notify';

export const sendTelegramNotification = async (message, type = '') => {
  // Fan out to Firebase push in parallel (opt-in via the notification-channel
  // setting; no-op on the default 'telegram'). Fire-and-forget.
  maybeSendPush(message, type);
  // If the user chose push ONLY, skip Telegram entirely.
  if (getNotificationChannel() === 'push') return;

  // Master switch: if Telegram notifications are globally disabled, send nothing.
  // (undefined/true → enabled, preserving behavior for existing users)
  try {
    const masterRaw = localStorage.getItem('appSettings');
    if (masterRaw && JSON.parse(masterRaw).telegramEnabled === false) return;
  } catch (_) {}

  // Check if this notification type is disabled by the user
  // speed_alert, geo_entry, geo_leave have their own dedicated toggles — skip generic filter for them
  if (type && type !== 'speed_alert' && type !== 'geo_entry' && type !== 'geo_leave') {
    const savedRaw = localStorage.getItem('appSettings');
    if (savedRaw) {
      try {
        const s = JSON.parse(savedRaw);
        if (s.telegramNotifications && s.telegramNotifications[type] === false) {
          return; // User disabled this type
        }
      } catch (_) {}
    }
  }


  const savedSettings = localStorage.getItem('appSettings');
  if (!savedSettings) return;
  
  try {
    const settings = JSON.parse(savedSettings);
    const chatId = settings.telegramChatId || '';
    if (!chatId) return;

    const authToken = await getAuthToken();
    await fetch('/api/telegram/send', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(authToken ? { Authorization: `Bearer ${authToken}` } : {})
      },
      body: JSON.stringify({ chatId, text: message })
    });
  } catch (err) {
    console.error('Telegram notification error:', err);
  }
};

